<template>
    <b-modal
        ref="search-or-add-substance-modal"
        cancel-variant="outline-secondary"
        ok-title="Save"
        @ok="onSave"
        size="lg"
        cancel-title="Close"
        centered
        hide-footer
        :title="$t('Component(SearchOrAddSubstanceModal):label')"
        @hidden="hidden"
    >
        <SearchOrAddSubstance
            input-label=""
            @include="(substance) => $emit('include', substance)"
        />
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import SearchOrAddSubstance from "@/views/product/components/product-card/SearchOrAddSubstance.vue";

export default {
    components: {
        SearchOrAddSubstance,
        BModal,
    },

    methods: {
        hidden() {
          this.$emit('modalClosed');
        },
        onSave() {
            console.log('save');
        },

        show() {
            this.$refs['search-or-add-substance-modal'].show();
        },

        hide() {
            this.$refs['search-or-add-substance-modal'].hide();
        },
    },
}
</script>
